import anime from 'animejs'

// factory method to add delay, begin and complete parameters to all animation methods
const createAnimation = (callback, options, context) => {
  return () => {

    const tl = anime.timeline()
    const blankMethod = () => {
      return
    }

    options = options || {}
    options.begin = options.begin || blankMethod
    options.complete = options.complete || blankMethod
    options.delay = options.delay || 0

    setTimeout(() => {
      callback(tl, options)
    }, options.delay)

    return context
    
  }
}

export {createAnimation}


// WEBPACK FOOTER //
// ./src/assets/js/utils/createAnimation.js